
import {Component, OnInit} from '@angular/core';
import {ApiKeyService} from '../api-key.service';
import {NotificationType} from '../../core/notify/index';
import {NotificationBarService} from '../../core/notify/notification.service';
import {GlobalService} from '../../global/global.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-api-key',
  templateUrl: './api-key.component.html',
  styleUrls: ['./api-key.component.scss']
})
export class ApiKeyComponent implements OnInit {

  isLoading = false;
  hasKey = false;
  apiKey: any;
  apiKeys: any;



  constructor(private apiKeyService: ApiKeyService,
              private notifier: NotificationBarService,
              private global: GlobalService) { }

  ngOnInit() {
     this.getApiKeys();
  }

  private setKeys(response) {
    this.apiKeys = response;
    this.hasKey = this.apiKeys.length ? true : false;
    this.apiKey = this.apiKeys.filter(key => key.timeToLive === -1 || !key.timeToLive )[0];
    this.isLoading = false;
  }

  private getApiKeys() {
    this.isLoading = true;
    this.apiKeyService.getApiKeys()
      .subscribe((response) => {
         this.setKeys(response);
      },
        (error) => {
          this.isLoading = false;
          this.notifier.create({type: NotificationType.Error, message: error});
        });
  }



  onKeyRegenerated(response) {
    this.setKeys(response);
  }

  onKeyGenerated(response) {
    this.apiKeys = [response];
    this.apiKey = response;
    this.hasKey = true;
  }

  onKeyDelete($event) {
    this.hasKey = false;
    this.apiKeys = null;
    this.apiKey = null;
  }




}



// WEBPACK FOOTER //
// ./src/app/accounts/api-key/api-key.component.ts